export const SET_PLANS = "ACTION_PLANS/SET_PLANS";
export const SET_PLAN = "ACTION_PLANS/SET_PLAN";
export const SET_PLAN_ITEMS = "ACTION_PLANS/SET_PLAN_ITEMS";
export const SET_PLAN_HOW_MUCH = "ACTION_PLANS/SET_PLAN_HOW_MUCH";
